module.exports = __webpack_public_path__ + "static/szkoleniowa-4-13e015efabbfa25c452db2c0c244df91.jpg";